import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly platformId = inject(PLATFORM_ID);

  public set(key: string, value: string): void {
    if(isPlatformBrowser(this.platformId)){
    if (key && value) localStorage.setItem(key, value);
  }
  }

  public get(key: string): any {
    if(isPlatformBrowser(this.platformId)){
    if (key)
      return localStorage.getItem(key);
    return null;
}
  }

  public remove<T>(key: string): void {
    if(isPlatformBrowser(this.platformId)){
    localStorage.removeItem(key);
    }
  }
}
